import { API } from "./API";
import getUserVariation from "../utils/ABTesting";
const REPORT_BASE = "https://ping.fastsimon.com";
export const PostLoad = ({ storeID, uuid, cartToken, sessionToken, userSession }) => {
    var _a;
    const params = {
        source: "fast-simon-reporting",
        UUID: uuid,
        store_id: storeID,
        api_type: "json",
        cart_token: cartToken,
        st: userSession !== null && userSession !== void 0 ? userSession : undefined,
        session: sessionToken.start,
        doc_ref: document.referrer,
        variation_id: getUserVariation()
    };
    if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) {
        params['qs'] = encodeURIComponent(window.location.search);
    }
    return API.get({
        url: `${REPORT_BASE}/post_load`,
        params: params
    });
};
//# sourceMappingURL=postLoad.js.map